export { default } from '../de/Tos';



// WEBPACK FOOTER //
// ./src/components/async/deTos.js